import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { addStoreChatItem } from './addStoreChatItem';
import { createSafeAction, type SafeAction } from './createSafeAction';
import { createStoreError } from './createStoreError';
import type { ChatStoreAction } from './types';

type AddErrorMessageArgs = {
	error: unknown;
	conversationId?: string;
	errorPrefix?: string;
};

export const addErrorMessage: SafeAction<[AddErrorMessageArgs]> = createSafeAction(
	StoreActionLoggableName.addErrorMessage,
	({ error, conversationId, errorPrefix }: AddErrorMessageArgs): ChatStoreAction =>
		({ dispatch }) => {
			dispatch(
				addStoreChatItem({
					message: createStoreError(error, errorPrefix),
					conversationId,
				}),
			);
		},
);
